import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { toast } from "react-toastify";

import {
	fetchMarketListings,
	setMarketListings,
} from "../../../_redux/actions/market";

import { hasItems } from "../../../helpers/Utils";
import { MarketPlaceProvider } from "./MarketPlaceContext";

import MarketHeader from "./MarketHeader/MarketHeader";
import MarketFilters from "./listings/filters/MarketFilters";
import MarketProductsList from "./listings/products/MarketProductsList";
import MarketEmptyPage from "./listings/products/MarketEmptyPage";
import MarketLoading from "./MarketLoading";

import s from "./MarketPage.module.scss";

export default function MarketPage({ user }) {
	const dispatch = useDispatch();
	const location = useLocation();

	const [products, setProducts] = useState([]);
	const [allProducts, setAllProducts] = useState([]);
	const [filters, setFilters] = useState({});

	const searchParams = new URLSearchParams(location.search);
	const category = searchParams.get("category");

	const { listings, isFetching } = useSelector((state) => state.market || {});

	useEffect(() => {
		if (hasItems(listings)) {
			setAllProducts(listings);
			setProducts(listings);
		} else {
			// Loading default listings
			dispatch(fetchMarketListings({ page: 1 }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setAllProducts(listings);
		setProducts(listings);
		setFilters({ ...(filters || {}) });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [listings]);

	// Filter by category when coming from details category selection
	useEffect(() => {
		if (category) {
			const cat = category.toLocaleLowerCase();
			dispatch(fetchMarketListings({ categories: [category] }));
			setFilters({ ...filters, categories: [cat] });
		} else {
			setFilters({});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [category]);

	// ------------------------------------- SEARCH -------------------------------------
	const filterResults = (incomingFilters = {}, reset = false) => {
		const newFilters = reset ? {} : { ...filters, ...incomingFilters };
		const { searchText, categories = [] } = newFilters;

		// Filter by search text or categories
		dispatch(fetchMarketListings({ searchText, categories }));

		//setProducts([...filteredData]);
		setFilters(newFilters);
	};

	// ------------------------------------- UPLOAD DEMO DATA -------------------------------------
	const onUploadComplete = (fileContent = {}) => {
		const { listings: demoListings } = fileContent;

		// Add missing fields
		//const defaultListing = PRODUCTS[0];
		const demoProducts = demoListings.map((l) => ({
			//...defaultListing,
			...l,
		}));

		setAllProducts(demoProducts);
		setProducts(demoProducts);
		dispatch(setMarketListings(demoProducts));
		setFilters({});
		toast.success("Listings loaded successfully!");
	};

	return (
		<div className={s.root}>
			<MarketPlaceProvider
				value={{
					filters,
					filterResults,
					categories: (allProducts || []).map((p) => p.category),
				}}
			>
				<div className={s.header}>
					<MarketHeader user={user} onFileLoadComplete={onUploadComplete} />
					<div className={s.title}>Marketplace</div>
					<MarketFilters />
				</div>

				<div className={s.content}>
					{isFetching ? (
						<MarketLoading />
					) : hasItems(products) ? (
						<MarketProductsList products={products} />
					) : (
						<MarketEmptyPage searchText={filters.searchText} />
					)}
				</div>
			</MarketPlaceProvider>
		</div>
	);
}
